var AuthFormResetPassword = ( function($) {

    var AuthFormResetPassword = function(options) {
        this.init(options);
    };

    var Self = AuthFormResetPassword;
    Self.className = 'AuthFormResetPassword';
    var Parent = ActionformAbstract;

    var def = ActionformAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;
        Parent.prototype.init.call(that, options);
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-resetpassword',
            next_action: '.js-form-login',
            previous_action: '',
        };

        that.method = 'POST';

        that.url = $.sa.build_url('auth/reset-password/perform');
        that.next_url = def(options.next_url, ''); // reload current page by default
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    return Self;
})(jQuery);
